import styled, { css } from 'styled-components';
const Text = styled.span`
  ${({
  numberOfLines
}) => numberOfLines && css`
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-line-clamp: ${numberOfLines}; /* number of lines to show */
      -webkit-box-orient: vertical;
    `};
`;
export default Text;